import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { FolderCounts, NoteDetail } from "../../api/schemas/notes";
import { RecordSummary } from "../../api/schemas/records";

/** Unsaved changes; the body arrives through `NoteEditorChanged`. */
export const Draft = S.Struct({ title: S.String, body: S.String });
export type Draft = typeof Draft.Type;

export const Model = S.Struct({
	/** The note id from the route. */
	id: S.String,
	/** Live note, links and backlinks (KTD8: not time-versioned, no asOf tag). */
	note: apiData(NoteDetail).schema,
	/** The folder tree beside the note (live, like the note). */
	folders: apiData(FolderCounts).schema,
	/** Folders whose default open state the reader flipped (widgets/folderTree). */
	toggled: S.Array(S.String),
	/** Epoch ms read with the note, for "updated 2 hr ago". */
	now: S.Number,
	/** Records behind person links and ambiguous candidates, by id: mini-briefs and chooser labels. */
	records: S.Record(S.String, RecordSummary),
	/** The ambiguous link (by `raw`) whose chooser is open. */
	chooser: S.Option(S.String),
	/** Some while title or body differ from the saved note (the page is always editable). */
	draft: S.Option(Draft),
	saving: S.Boolean,
	/** The save hit 409: someone else saved first. */
	conflict: S.Boolean,
	/** The broken-link target being created. */
	creating: S.Option(S.String),
	error: S.Option(S.String),
});
export type Model = typeof Model.Type;
